/** Format a decimal price string for display in a given currency. */
export function formatPrice(price: string, currency: string): string {
  const num = parseFloat(price);
  const currencyFormats: Record<string, (n: number) => string> = {
    TWD: (n) => `NT$${Math.round(n).toLocaleString()}`,
    USD: (n) => `$${n.toFixed(2)}`,
    EUR: (n) => `€${n.toFixed(2)}`,
    JPY: (n) => `¥${Math.round(n).toLocaleString()}`,
    GBP: (n) => `£${n.toFixed(2)}`,
  };
  const formatter = currencyFormats[currency];
  return formatter ? formatter(num) : `${num.toFixed(2)} ${currency}`;
}
